import { Box } from '@ff-it/ui';
import { useListSeenToggle } from 'modules/notifications';
import type { Notification } from 'modules/notifications/types';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router';

export function NotificationClickHandler({ notification }: { notification: Notification }): ReactElement {
  const handleToggle = useListSeenToggle(notification);
  const navigate = useNavigate();

  const {
    fields: { title, cta },
    last_seen_at,
  } = notification;
  const isSeen = Boolean(last_seen_at);

  const content = title || '—';
  const onClickHandler = async () => {
    if (!isSeen) {
      await handleToggle();
    }
    if (cta) {
      navigate(cta.url);
    }
  };
  return (
    <Box as="span" role="button" onClick={onClickHandler} color={cta ? 'primary' : 'body'}>
      {content}
    </Box>
  );
}
